import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { requestInvoiceBatchOrdersExportTemplate } from 'apollo/templates/invoice-batches';
import { AsyncExportEventData, useAsyncExport } from './useAsyncExport';

export const INVOICE_BATCH_EXPORT_EVENTS = {
    ready: 'INVOICE_BATCH_EXPORT_READY',
    error: 'INVOICE_BATCH_EXPORT_ERROR',
} as const;

type UseInvoiceBatchExportOptions = {
    batchId?: string;
};

/** Excel export with one row per action/material line of every order in an invoice batch run. */
export const useInvoiceBatchExport = ({ batchId }: UseInvoiceBatchExportOptions) => {
    const { t: translate } = useTranslation(['invoices']);
    const variables = useMemo(() => ({ id: batchId }), [batchId]);
    const isForThisScope = useCallback((data: AsyncExportEventData) => data.batchId === batchId, [batchId]);
    return useAsyncExport({
        mutation: requestInvoiceBatchOrdersExportTemplate,
        variables,
        events: INVOICE_BATCH_EXPORT_EVENTS,
        isForThisScope,
        emptyMessage: translate('invoices:EXPORT_NO_ORDERS'),
    });
};
